import styled from "@emotion/styled";

export default function Orders() {
  return (
    <OrdersContainer>
      <h1>ORDERS</h1>
    </OrdersContainer>
  );
}

const OrdersContainer = styled.div``;
